import md5 from "md5";
import { useContext, useState } from "react";
import axios from "axios";
import "../assets/css/pages/base/login/login.css";
import { AuthContext } from "../contexts";
import MainLogo from "../assets/images/main-logo.png";
import { Link, Navigate, useLocation } from "react-router-dom";
import { ArrowCircleRightIcon } from "@phosphor-icons/react";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loader, setLoader] = useState(false);
    const [redirectToReferrer, setRedirectToReferrer] = useState(false);
    const { state } = useLocation();
    const { user, setToken } = useContext(AuthContext);

    if (redirectToReferrer === true || user) {
        return <Navigate to={state?.from || "/admin"} />;
    }

    const handleSubmit = (event) => {
        if (event.type === "click" || event.key === "Enter") {
            setLoader(true);
            axios
                .post(process.env.REACT_APP_UPA_API_HOST + "login", {
                    email: email,
                    password: md5(password),
                })
                .then((response) => {
                    setLoader(false);
                    localStorage.setItem("session_token", response.data.token);
                    setToken(response.data.token);
                    setRedirectToReferrer(true);
                })
                .catch((error) => {
                    setError(error.response.data.message);
                    setLoader(false);
                });
        }
    };

    return (
        <div className="main-login">
            <div className="login-background" />
            <div className="login-container">
                <div className="login-form">
                    <div className="img-container">
                        <img src={MainLogo} alt="logo" width={180} />
                    </div>
                    <div className="c-modal-content">
                        <div className="login-header">
                            <h1>Bienvenue</h1>
                            <p className="welcome-message">Connectez-vous à Altelis Tools</p>
                        </div>
                        {error ? <p className="login-error">{error}</p> : null}
                        <div className="custom__modal-group">
                            <label className="email">
                                Email <span className="required-asterisk">*</span>
                            </label>
                            <input
                                type="email"
                                placeholder="Saisissez votre adresse email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setError("");
                                }}
                                onKeyUp={(e) => handleSubmit(e)}
                                className="classic-input"
                            />
                        </div>
                        <div className="custom__modal-group">
                            <label className="password">
                                Mot de passe <span className="required-asterisk">*</span>
                            </label>
                            <input
                                type="password"
                                placeholder="Saisissez votre mot de passe"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setError("");
                                }}
                                onKeyUp={(e) => handleSubmit(e)}
                                className="classic-input"
                            />
                        </div>
                        <Link to="/forgot-password" className="forgot-password">
                            Mot de passe oublié ?
                        </Link>
                        <div className="login-button-container">
                            {loader ? (
                                <button className="button-large blue-button" disabled>
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                                </button>
                            ) : (
                                <button className="button-large blue-button" type="submit" onClick={handleSubmit}>
                                    <span>Se connecter</span>
                                    <ArrowCircleRightIcon size={16} weight="bold" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
